var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCloseNotactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 1.946c-7.747 0.002-14.053 6.307-14.054 14.054 0.002 7.749 6.304 14.053 14.051 14.053h0.003c7.75 0 14.053-6.302 14.053-14.053 0.002-7.747-6.301-14.053-14.053-14.054zM15.997 28.134c-6.688-0.002-12.13-5.443-12.13-12.134 0-6.69 5.443-12.133 12.133-12.133 3.24 0 6.29 1.264 8.579 3.555 2.293 2.29 3.555 5.338 3.555 8.578 0 6.691-5.445 12.134-12.138 12.134z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.758 10.243c-0.371-0.374-0.981-0.374-1.357 0l-4.4 4.4-4.402-4.403c-0.374-0.374-0.982-0.374-1.358 0s-0.374 0.982 0 1.358l4.403 4.402-4.403 4.402c-0.374 0.373-0.374 0.981 0 1.357 0.187 0.187 0.434 0.282 0.678 0.282s0.491-0.094 0.678-0.282l4.402-4.402 4.4 4.398c0.187 0.187 0.434 0.282 0.678 0.282s0.493-0.094 0.678-0.282c0.374-0.374 0.374-0.982 0-1.357l-4.398-4.398 4.4-4.398c0.374-0.376 0.374-0.984 0-1.358z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseNotactive);
export default __webpack_public_path__ + "static/media/icon-close-notactive.e0a0b3e2.svg";
export { ForwardRef as ReactComponent };